module.exports = __webpack_public_path__ + "static/img/12.958fedc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/2/zh/12.png
// module id = VILN
// module chunks = 0